<div class="container p-4 md:p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-semibold">Cadastro de Marcas</h1>

  <form #marcaForm="ngForm" name="marcaForm" class="space-y-4">
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 flex flex-col">
        <label for="nome" class="mb-1 font-medium text-gray-700">Nome</label>
        <input pInputText id="nome" type="text" placeholder="Nome" [(ngModel)]="marca.nome" name="nome" class="w-full p-2 border border-gray-300 rounded" />
      </div>
    </div>

    <div class="flex space-x-4 pt-4">
      <div class="button-group">
        <button *ngIf="!editMode" pButton type="button" class="btn btn-primary btn-md" (click)="cadastrar()">
          <i class="pi pi-check mr-2"></i>
          <span>Cadastrar</span>
        </button>
        <button *ngIf="editMode" pButton type="button" class="btn btn-primary btn-md" (click)="salvarAlteracao()">
          <i class="pi pi-save mr-2"></i>
          <span>Salvar</span>
        </button>
        <button *ngIf="editMode" pButton type="button" class="btn btn-secondary btn-md" (click)="cancelarEdicao()">
          <i class="pi pi-times mr-2"></i>
          <span>Cancelar</span>
        </button>
      </div>
    </div>
  </form>

  <div class="overflow-x-auto">
    <p-table [value]="marcas" class="w-full mt-6">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-2 border-b text-left">Id</th>
          <th class="p-2 border-b text-left">Nome</th>
          <th class="p-2 border-b text-left">Situação</th>
          <th class="p-2 border-b text-left">Data Cadastro</th>
          <th class="p-2 border-b text-left">Data Última Modificação</th>
          <th class="p-2 border-b text-left">Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-marca>
        <tr>
          <td class="p-2 border-b">{{ marca.id }}</td>
          <td class="p-2 border-b">{{ marca.nome }}</td>
          <td class="p-2 border-b">
            <ng-container *ngIf="marca.ativo !== false; else notActive">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800">Ativo</span>
            </ng-container>
            <ng-template #notActive>
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-800">Desativado</span>
            </ng-template>
          </td>
          <td class="p-2 border-b">{{ marca.dataCadastro | date : "dd/MM/yyyy HH:mm:ss" }}</td>
          <td class="p-2 border-b">{{ marca.dataUltimaModificacao | date : "dd/MM/yyyy HH:mm:ss" }}</td>
          <td class="p-2 border-b">
            <div class="flex items-center space-x-1">
              <button pButton type="button" class="p-button-text p-button-sm text-gray-700" title="Editar marca" (click)="editar(marca)">
                <i class="pi pi-pencil"></i>
              </button>
              <button pButton type="button" class="p-button-text p-button-sm" [ngClass]="marca.ativo ? 'text-red-600' : 'text-green-600'" [title]="marca.ativo ? 'Desativar marca' : 'Ativar marca'" (click)="confirmarAtivarDesativar(marca)">
                <i [ngClass]="marca.ativo ? 'pi pi-ban text-red-600' : 'pi pi-user-plus text-green-600'"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
